// CX Environment Types
export var Environments;
(function (Environments) {
    Environments["Production"] = "production";
    Environments["Staging"] = "staging";
    Environments["Development"] = "development";
})(Environments || (Environments = {}));
// --- CX (client-experience) environment ---------------------------------
// Colocated with the general environment system above. This is a parallel,
// CX-specific variant (the resolver adds `awsBucket` + cpu/cpd/cpp
// impersonation, and pre-resolves the S3 `configDomain`/`filePrefix` used to
// locate per-company branding configuration). It intentionally duplicates
// `Environments`/`IEnvironment`/`TDomains` — the two systems are kept together
// here so they can be unified when this (anti-pattern) package is dissolved.
// Moved out of `src/types/cx-types/`.
export var CXEnvironments;
(function (CXEnvironments) {
    CXEnvironments["Production"] = "production";
    CXEnvironments["Staging"] = "staging";
    CXEnvironments["Development"] = "development";
})(CXEnvironments || (CXEnvironments = {}));
//# sourceMappingURL=types.js.map